const config = require('./config/config');
module.exports.FuzzyReaction = require('fuzzy-reaction')(config);
